// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputWrapper {
  position: relative;
}
.inputWrapper input {
  border-radius: 4px;
  border: 1px solid #DCDCDC;
  background: #ffffff;
  font-size: 18px;
  font-weight: 400;
  line-height: normal;
  padding: 8px 16px 8px 56px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .inputWrapper input {
    padding: 8px 16px 8px 44px;
  }
}
.inputWrapper input:focus-visible {
  outline: none;
}
.inputWrapper .inputErrorBox {
  border-color: #EB0000;
}
.inputWrapper svg {
  position: absolute;
  left: 16px;
  top: 8px;
  width: auto;
  height: 20px;
}
@media (max-width: 768px) {
  .inputWrapper svg {
    height: 16px;
  }
}
.inputWrapper .error {
  color: #EB0000;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
}

input:disabled {
  background: #F7F7F7 !important;
  color: #e2e8f0 !important;
  border-color: #DCDCDC !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}

.disabledInputWrapper {
  opacity: 0.6;
}

.countryCodeDropdown {
  position: relative;
  width: 250px;
  z-index: 100;
}
@media (max-width: 768px) {
  .countryCodeDropdown {
    width: 100%;
  }
}
.countryCodeDropdown .countryCodeLabel {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #4a4a4a;
  margin-bottom: 4px;
}
.countryCodeDropdown .countryCodeTrigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  cursor: pointer;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #DCDCDC;
  background: #ffffff;
  font-size: 18px;
  font-weight: 400;
  line-height: normal;
  transition: all 0.2s ease;
}
@media screen and (max-width: 767px) {
  .countryCodeDropdown .countryCodeTrigger {
    padding: 7px 16px;
    font-size: 14px;
    height: 33px;
  }
}
.countryCodeDropdown .countryCodeTrigger:hover:not(.disabled) {
  border-color: #808080;
}
.countryCodeDropdown .countryCodeTrigger.disabled {
  background-color: #F7F7F7;
  cursor: not-allowed;
}
.countryCodeDropdown .countryCodeTrigger .countryCodeSelected .countryCodeText {
  color: #000000;
  display: flex;
  gap: 8px;
  flex-direction: row-reverse;
}
.countryCodeDropdown .countryCodeTrigger .countryCodeSelected .countryCodeText .countryText {
  width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.countryCodeDropdown .countryCodeMenu {
  position: absolute;
  width: 100%;
  margin-top: 8px;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}
@media (max-width: 768px) {
  .countryCodeDropdown .countryCodeMenu {
    width: 100%;
  }
}
.countryCodeDropdown .countryCodeMenu .countryCodeSearch {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  padding: 8px;
  border-bottom: 1px solid #d1d5db;
  z-index: 1;
}
.countryCodeDropdown .countryCodeMenu .countryCodeSearch .countryCodeSearchContainer {
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
.countryCodeDropdown .countryCodeMenu .countryCodeSearch .countryCodeSearchContainer .countryCodeSearchInput {
  width: 100%;
  padding: 8px 8px 8px 32px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
}
.countryCodeDropdown .countryCodeMenu .countryCodeSearch .countryCodeSearchContainer .countryCodeSearchIcon {
  position: absolute;
  left: 8px;
  top: 10px;
  color: #1e3a8a;
  width: 16px;
  height: 16px;
}
.countryCodeDropdown .countryCodeMenu .countryCodeScrollableList {
  max-height: 200px;
  overflow: auto;
}
.countryCodeDropdown .countryCodeMenu .countryCodeScrollableList .countryCodeList .countryCodeItem {
  display: flex;
  align-items: flex-start;
  padding: 8px 12px;
  cursor: pointer;
  gap: 4px;
}
.countryCodeDropdown .countryCodeMenu .countryCodeScrollableList .countryCodeList .countryCodeItem:hover {
  background-color: #F7F7F7;
}
.countryCodeDropdown .countryCodeMenu .countryCodeScrollableList .countryCodeList .countryCodeItem .countryCodeDial {
  margin-left: auto;
  color: #616161;
}
.countryCodeDropdown .countryCodeMenu .countryCodeScrollableList .countryCodeList .countryCodeNoResults {
  padding: 8px 12px;
  color: #616161;
}

.creditCardInput {
  display: flex;
  justify-content: space-between;
  text-align: center;
  gap: 16px;
  color: #4b5563;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-weight: 400;
  font-size: 18px;
}
@media screen and (min-width: 300px) and (max-width: 450px) {
  .creditCardInput .cardInput {
    height: 48px;
    font-size: 16px;
  }
}
@media screen and (min-width: 451px) and (max-width: 767px) {
  .creditCardInput {
    gap: 4px;
  }
  .creditCardInput .cardInput {
    font-size: 16px;
  }
}
@media (max-width: 768px) {
  .creditCardInput {
    gap: 4px;
    font-size: 16px;
  }
}
.creditCardInput .cardInput {
  width: 50%;
  -webkit-appearance: none;
          appearance: none;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  border-radius: 6px;
  height: 48px;
  border: 1px solid #e5e7eb;
  outline: none;
  padding: 8px 0;
  text-align: center;
  background-color: #F7F7F7;
  font-weight: 400;
  color: #1e293b;
}
.creditCardInput .cardInput::placeholder {
  color: #1e293b;
  font-weight: 400;
}

.successLoginMessage {
  display: flex;
  margin-top: 8px;
  gap: 8px;
  font-size: 14px;
  color: #00A664;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
}

.errorLoginMessage {
  display: flex;
  margin-top: 8px;
  gap: 8px;
  font-size: 14px;
  color: #EB0000;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
}

.OTPInputWrapper {
  width: 100%;
  position: relative;
}
.OTPInputWrapper .otpInput {
  width: 100%;
  border-radius: 10px;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  height: 60px;
  border: 1px solid #E5E5E5;
  outline: none;
  padding: 12px 24px;
  background-color: #F7F7F7;
  color: #1E1E1E;
  font-size: 18px;
  font-weight: 500;
}
.OTPInputWrapper .otpInput::placeholder {
  font-weight: 400;
  color: #616161;
}
.OTPInputWrapper .redStar {
  position: absolute;
  top: 28px;
  left: 112px;
  transform: translateY(-50%);
  color: #EB0000;
  font-size: 16px;
  pointer-events: none;
  display: var(--redStarDisplay);
}
.OTPInputWrapper .errorOtp {
  padding: 8px 16px;
  color: #EB0000;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-size: 12px;
}
.OTPInputWrapper .resendText {
  padding: 12px 0;
  position: absolute;
  top: 6px;
  right: 16px;
  font-family: "Inter Tight", sans-serif;
  font-family: var(--primary-font, "Inter Tight", sans-serif);
}
.OTPInputWrapper .resendText .textResend {
  font-weight: 500;
  font-size: 14px;
}
.OTPInputWrapper .otpInput:focus + .redStar {
  display: none;
}

.countryCodePhoneNumberWrapper {
  width: 100%;
  padding-top: 0px;
  position: relative;
  z-index: 100;
  margin-top: 4px;
}
.countryCodePhoneNumberWrapper .phoneInputWrapper {
  position: relative;
  z-index: 0;
}
.countryCodePhoneNumberWrapper .phoneInputWrapper .editIcon {
  z-index: 10;
  font-weight: 500;
  font-size: 14px;
  text-decoration: underline;
  padding: 12px 0;
  position: absolute;
  top: 8px;
  right: 16px;
  font-family: "Inter Tight", sans-serif;
  font-family: var(--primary-font, "Inter Tight", sans-serif);
  cursor: pointer;
}
.countryCodePhoneNumberWrapper .successMessage {
  display: flex;
  margin-top: 8px;
  gap: 6px;
  font-size: 12px;
  color: #00A664;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
  font-weight: 500;
}
.countryCodePhoneNumberWrapper .errorMessage {
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #EB0000;
  font-family: "Inter", sans-serif;
  font-family: var(--primary-font, "Inter", sans-serif);
}`, "",{"version":3,"sources":["webpack://./src/Components/Partials/Input/Input.scss","webpack://./src/Styles/_colors.scss","webpack://./src/Styles/_mixins.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;AAAF;AAEE;EACE,kBAAA;EACA,yBAAA;EACA,mBCHU;EDIV,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;AAAJ;AEAE;EFRA;IAWI,0BAAA;EACJ;AACF;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,qBCGQ;ADJZ;AAIE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EAEA,WAAA;EACA,YAAA;AAHJ;AElBE;EFeA;IASI,YAAA;EAFJ;AACF;AAKE;EACE,cCdQ;EDeR,eAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;;AAQA;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQE;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AALF;AE/CE;EFiDA;IAME,WAAA;EAJF;AACF;AAIK;EACD,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cC7DwB;ED8DxB,kBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBCjFU;EDkFV,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAHJ;AAKI;EAfF;IAgBI,iBAAA;IACA,eAAA;IACA,YAAA;EAFJ;AACF;AAII;EACE,qBCtFqB;ADoF3B;AAKI;EACE,yBCjFY;EDkFZ,mBAAA;AAHN;AAOM;EACE,cCvGM;EDwGN,aAAA;EACA,QAAA;EACA,2BAAA;AALR;AAOQ;EACE,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AALV;AAWE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,yBC3HU;ED4HV,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;AATJ;AE9GE;EF+GA;IAWI,WAAA;EARJ;AACF;AAUI;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,yBCxIQ;EDyIR,YAAA;EACA,gCAAA;EACA,UAAA;AARN;AAUM;EACE,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;AARR;AAUQ;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AARV;AAWQ;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,cCnDO;EDoDP,WAAA;EACA,YAAA;AATV;AAcI;EACE,iBAAA;EACA,cAAA;AAZN;AAeQ;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;AAbV;AAeU;EACE,yBCnKM;ADsJlB;AAgBU;EACE,iBAAA;EACA,cC9KM;ADgKlB;AAkBQ;EACE,iBAAA;EACA,cCpLQ;ADoKlB;;AAwBA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,cCvIe;EDwIf,gCAAA;EAAA,qDAAA;EACA,gBAAA;EACA,eAAA;AArBF;AAuBE;EACE;IACE,YAAA;IACA,eAAA;EArBJ;AACF;AAwBE;EAjBF;IAkBI,QAAA;EArBF;EAsBE;IACE,eAAA;EApBJ;AACF;AEhME;EF+LF;IAyBI,QAAA;IACA,eAAA;EApBF;AACF;AAsBE;EACE,UAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gCAAA;EAAA,qDAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBC7Nc;ED8Nd,gBAAA;EACA,cChJe;AD4HnB;AAsBI;EACE,cCnJa;EDoJb,gBAAA;AApBN;;AAyBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,cCzOY;ED0OZ,gBAAA;EACA,gCAAA;EAAA,qDAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,cCjPU;EDkPV,gBAAA;EACA,gCAAA;EAAA,qDAAA;AAtBF;;AAyBA;EACE,WAAA;EAEA,kBAAA;AAvBF;AAyBE;EACE,WAAA;EACA,mBAAA;EACA,gCAAA;EAAA,qDAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBCzQc;ED0Qd,cC9PU;ED+PV,eAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,gBAAA;EACA,cCvRc;AD+PlB;AA2BE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,cCnRQ;EDoRR,eAAA;EACA,oBAAA;EACA,8BAAA;AAzBJ;AA4BE;EACE,iBAAA;EACA,cC3RQ;ED4RR,gCAAA;EAAA,qDAAA;EACA,eAAA;AA1BJ;AA6BE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,sCAAA;EAAA,2DAAA;AA3BJ;AA6BI;EACE,gBAAA;EACA,eAAA;AA3BN;AA+BE;EACE,aAAA;AA7BJ;;AAiCA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AA9BF;AAoCE;EACE,kBAAA;EACA,UAAA;AAlCJ;AAoCI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,sCAAA;EAAA,2DAAA;EACA,eAAA;AAlCN;AAsCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,cCtVU;EDuVV,gCAAA;EAAA,qDAAA;EACA,gBAAA;AApCJ;AAuCE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cChWQ;EDiWR,gCAAA;EAAA,qDAAA;AArCJ","sourcesContent":["@import \"src/Styles/theme.scss\";\n.inputWrapper {\n  position: relative;\n\n  input {\n    border-radius: 4px;\n    border: 1px solid $border-color-light-grey;\n    background: $color-white;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: normal;\n    padding: 8px 16px 8px 56px;\n    transition: all 0.2s ease;\n\n    @include respond-md {\n      padding: 8px 16px 8px 44px;\n    }\n  }\n\n  input:focus-visible {\n    outline: none;\n  }\n\n  .inputErrorBox {\n    border-color: $color-red;\n  }\n\n  svg {\n    position: absolute;\n    left: 16px;\n    top: 8px;\n    // fill: $color-border-primary-grey;\n    width: auto;\n    height: 20px;\n\n    @include respond-md {\n      height: 16px;\n    }\n  }\n\n  .error {\n    color: $color-red;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18px;\n    // position: absolute;\n  }\n}\n\ninput:disabled {\n  background: $bg-light-grey-2 !important;\n  color: $color-border-primary-grey!important;\n  border-color: $border-color-light-grey !important;\n  cursor: not-allowed !important;\n  pointer-events: none !important;\n}\n\n.disabledInputWrapper {\n  opacity: 0.6;\n}\n\n  .countryCodeDropdown {\n  position: relative;\n  width: 250px;\n  z-index: 100;\n\n  @include respond-md {\n    width: 100%;\n  }  .countryCodeLabel {\n    display: block;\n    font-size: 14px;\n    font-weight: 500;\n    color: $color-primary-medium-grey;\n    margin-bottom: 4px;\n  }\n\n  .countryCodeTrigger {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 16px;\n    cursor: pointer;\n    height: 40px;\n    border-radius: 4px;\n    border: 1px solid $border-color-light-grey;\n    background: $color-white;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: normal;\n    transition: all 0.2s ease;\n\n    @media screen and (max-width: 767px) {\n      padding: 7px 16px;\n      font-size: 14px;\n      height: 33px;\n    }\n\n    &:hover:not(.disabled) {\n      border-color: $color-primary-light-grey;\n    }\n\n    &.disabled {\n      background-color: $bg-light-grey-2;\n      cursor: not-allowed;\n    }\n\n    .countryCodeSelected {\n      .countryCodeText {\n        color: $color-black;\n        display: flex;\n        gap: 8px;\n        flex-direction: row-reverse;\n\n        .countryText {\n          width: 150px;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n\n  .countryCodeMenu {\n    position: absolute;\n    width: 100%;\n    margin-top: 8px;\n    background-color: $color-white;\n    border: 1px solid $color-gray-300;\n    border-radius: 4px;\n    box-shadow: 0 4px 6px $color-border;\n    z-index: 1000;\n\n    @include respond-md {\n      width: 100%;\n    }\n\n    .countryCodeSearch {\n      position: sticky;\n      top: 0;\n      background-color: $color-white;\n      padding: 8px;\n      border-bottom: 1px solid $color-gray-300;\n      z-index: 1;\n\n      .countryCodeSearchContainer {\n        position: relative;\n        display: flex;\n        flex-direction: row-reverse;\n        justify-content: flex-end;\n        align-items: center;\n        gap: 8px;\n\n        .countryCodeSearchInput {\n          width: 100%;\n          padding: 8px 8px 8px 32px;\n          border: 1px solid $color-gray-300;\n          border-radius: 4px;\n        }\n\n        .countryCodeSearchIcon {\n          position: absolute;\n          left: 8px;\n          top: 10px;\n          color: $color-blue-900;\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n\n    .countryCodeScrollableList {\n      max-height: calc(240px - 40px);\n      overflow: auto;\n\n      .countryCodeList {\n        .countryCodeItem {\n          display: flex;\n          align-items: flex-start;\n          padding: 8px 12px;\n          cursor: pointer;\n          gap: 4px;\n\n          &:hover {\n            background-color: $bg-light-grey-2;\n          }\n\n          .countryCodeDial {\n            margin-left: auto;\n            color: $color-text-grey;\n          }\n        }\n\n        .countryCodeNoResults {\n          padding: 8px 12px;\n          color: $color-text-grey;\n        }\n      }\n    }\n  }\n}\n\n// credit card input styling\n.creditCardInput {\n  display: flex;\n  justify-content: space-between;\n  text-align: center;\n  gap: 16px;\n  color: $color-gray-600;\n  font-family: var(--primary-font, 'Inter', sans-serif);\n  font-weight: 400;\n  font-size: 18px;\n\n  @media screen and (min-width: 300px) and (max-width: 450px) {\n    .cardInput {\n      height: 48px;\n      font-size: 16px;\n    }\n  }\n\n  @media screen and (min-width: 451px) and (max-width: 767px) {\n    gap: 4px;\n    .cardInput {\n      font-size: 16px;\n    }\n  }\n\n  @include respond-md {\n    gap: 4px;\n    font-size: 16px;\n  }\n\n  .cardInput {\n    width: 50%;\n    appearance: none;\n    font-family: var(--primary-font, 'Inter', sans-serif);\n    border-radius: 6px;\n    height: 48px;\n    border: 1px solid $color-gray-200;\n    outline: none;\n    padding: 8px 0;\n    text-align: center;\n    background-color: $bg-light-grey-2;\n    font-weight: 400;\n    color: $color-silver-800;\n\n    &::placeholder {\n      color: $color-silver-800;\n      font-weight: 400;\n    }\n  }\n}\n\n.successLoginMessage {\n  display: flex;\n  margin-top: 8px;\n  gap: 8px;\n  font-size: 14px;\n  color: $color-green;\n  font-weight: 500;\n  font-family: var(--primary-font, 'Inter', sans-serif);\n}\n\n.errorLoginMessage {\n  display: flex;\n  margin-top: 8px;\n  gap: 8px;\n  font-size: 14px;\n  color: $color-red;\n  font-weight: 500;\n  font-family: var(--primary-font, 'Inter', sans-serif);\n}\n\n.OTPInputWrapper {\n  width: 100%;\n  // padding-top: 24px;\n  position: relative;\n\n  .otpInput{\n    width: 100%;\n    border-radius: 10px;\n    font-family: var(--primary-font, 'Inter', sans-serif);\n    height: 60px;\n    border: 1px solid $stroke-grey;\n    outline: none;\n    padding: 12px 24px;\n    background-color: $bg-light-grey-2;\n    color: $stroke-dark;\n    font-size: 18px;\n    font-weight: 500;\n  }\n\n  .otpInput::placeholder {\n    font-weight: 400;\n    color: $color-text-grey;\n  }\n\n  .redStar {\n    position: absolute;\n    top: 28px;\n    left: 112px;\n    transform: translateY(-50%);\n    color: $color-red;\n    font-size: 16px;\n    pointer-events: none;\n    display: var(--redStarDisplay);\n  }\n\n  .errorOtp {\n    padding: 8px 16px;\n    color: $color-red;\n    font-family: var(--primary-font, 'Inter', sans-serif);\n    font-size: 12px;\n  }\n\n  .resendText {\n    padding: 12px 0;\n    position: absolute;\n    top: 6px;\n    right: 16px;\n    font-family: var(--primary-font, 'Inter Tight', sans-serif);\n\n    .textResend {\n      font-weight: 500;\n      font-size: 14px;\n    }\n  }\n\n  .otpInput:focus+.redStar {\n    display: none;\n  }\n}\n\n.countryCodePhoneNumberWrapper{\n  width: 100%;\n  padding-top: 0px;\n  position: relative;\n  z-index: 100;\n  margin-top: 4px;\n\n  @include respond-md {\n    // padding-top: 24px;\n  }\n\n  .phoneInputWrapper{\n    position: relative;\n    z-index: 0;\n\n    .editIcon{\n      z-index: 10;\n      font-weight: 500;\n      font-size: 14px;\n      text-decoration: underline;\n      padding: 12px 0;\n      position: absolute;\n      top: 8px;\n      right: 16px;\n      font-family: var(--primary-font, 'Inter Tight', sans-serif);\n      cursor: pointer;\n    }\n  }\n\n  .successMessage {\n    display: flex;\n    margin-top: 8px;\n    gap: 6px;\n    font-size: 12px;\n    color: $color-green;\n    font-family: var(--primary-font, 'Inter', sans-serif);\n    font-weight: 500;\n  }\n\n  .errorMessage {\n    display: flex;\n    align-items: center;\n    margin-top: 8px;\n    gap: 8px;\n    font-size: 12px;\n    font-weight: 500;\n    color: $color-red;\n    font-family: var(--primary-font, 'Inter', sans-serif);\n  }\n  \n}","// ====================================\n// 🎨 Color Variables\n// ====================================\n\n$color-white: #ffffff;\n$color-black: #000000;\n\n// Primary Colors\n$color-primary-pink: #EA2466;\n$color-secondary-pink: #F5437E;\n$color-primary-dark-grey: #383838;\n$color-primary-medium-grey: #4a4a4a;\n$color-primary-light-grey: #808080;\n$color-border-primary-grey: #e2e8f0;\n// $color-border-primary-grey: #b4b4b4;\n$color-text-grey: #616161;\n\n// Background Colors\n$bg-pink-10: #FDECF2; // approximated 10% of #EA2466\n$bg-white: #FFFFFF;\n$bg-light-grey-1: #E8E8E8;\n$bg-light-grey-2: #F7F7F7;\n$bg-light-grey-3: #EDEDED;\n\n// Misc Colors\n$color-green: #00A664;\n$color-yellow: #FECE00;\n$color-red: #EB0000;\n$border-color-light-grey: #DCDCDC;\n\n// Stroke Colors\n$stroke-pink: #E11F60;\n$stroke-black: #000000;\n$stroke-dark: #1E1E1E;\n$stroke-grey: #E5E5E5;\n\n// Hover Colors\n$hover-pink: #CB104E;\n$hover-dark-grey: #484848;\n// $hover-light-grey: #EDEDED;\n\n// ====================================\n// ****** Precious Metals Theme *******\n// ====================================\n\n// Base Colors--\n$color-foreground: #252525;\n$color-primary: #030213;\n$color-secondary: #f2f1fc;\n$color-muted: #ececf0;\n$color-muted-foreground: #717182;\n$color-accent: #e9ebef;\n$color-destructive: #d4183d;\n$color-border: rgba(0, 0, 0, 0.1);\n$color-input: transparent;\n$color-input-background: #f3f3f5;\n$color-switch-background: #cbced4;\n$color-ring: #b50000;\n\n// Chart Colors--\n$chart-1: #f18b00;\n$chart-2: #3a9ac3;\n$chart-3: #6d91db;\n$chart-4: #f2ab00;\n$chart-5: #f9a800;\n\n// Gray Scale--\n$color-gray-50: #f9fafb;\n$color-gray-100: #f3f4f6;\n$color-gray-200: #e5e7eb;\n$color-gray-300: #d1d5db;\n$color-gray-400: #9ca3af;\n$color-gray-500: #6b7280;\n$color-gray-600: #4b5563;\n$color-gray-700: #374151;\n$color-gray-800: #1f2937;\n$color-gray-900: #111827;\n$color-gray-950: #030712;\n\n// Gold Colors\n$color-gold-50: #fffbeb;\n$color-gold-100: #fef3c7;\n$color-gold-200: #fde68a;\n$color-gold-300: #fcd34d;\n$color-gold-400: #fbbf24;\n$color-gold-500: #f59e0b;\n$color-gold-600: #d97706;\n$color-gold-700: #b45309;\n$color-gold-800: #92400e;\n$color-gold-900: #78350f;\n\n// Silver Colors\n$color-silver-50: #f8fafc;\n$color-silver-100: #f1f5f9;\n$color-silver-200: #e2e8f0;\n$color-silver-300: #cbd5e1;\n$color-silver-400: #94a3b8;\n$color-silver-500: #64748b;\n$color-silver-600: #475569;\n$color-silver-700: #334155;\n$color-silver-800: #1e293b;\n$color-silver-900: #0f172a;\n\n// Blue Colors\n$color-blue-50: #eff6ff;\n$color-blue-100: #dbeafe;\n$color-blue-200: #bfdbfe;\n$color-blue-300: #93c5fd;\n$color-blue-400: #60a5fa;\n$color-blue-500: #3b82f6;\n$color-blue-600: #2563eb;\n$color-blue-700: #1d4ed8;\n$color-blue-800: #1e40af;\n$color-blue-900: #1e3a8a;\n\n// Green Colors (Additional to system green)\n$color-green-50: #f0fdf4;\n$color-green-100: #dcfce7;\n$color-green-200: #bbf7d0;\n$color-green-300: #86efac;\n$color-green-400: #4ade80;\n$color-green-500: #22c55e;\n$color-green-600: #00A664;\n$color-green-700: #15803d;\n$color-green-800: #166534;\n$color-green-900: #14532d;\n\n// Red Colors (Additional to system red)\n$color-red-50: #fef2f2;\n$color-red-100: #fee2e2;\n$color-red-200: #fecaca;\n$color-red-300: #fca5a5;\n$color-red-400: #f87171;\n$color-red-500: #ef4444;\n$color-red-600: #EB0000;\n$color-red-700: #b91c1c;\n$color-red-800: #991b1b;\n$color-red-900: #7f1d1d;\n\n// Purple Colors\n$color-purple-50: #f5f3ff;\n$color-purple-100: #f3e8ff;\n$color-purple-200: #e9d5ff;\n$color-purple-300: #d8b4fe;\n$color-purple-400: #c084fc;\n$color-purple-500: #a855f7;\n$color-purple-600: #9333ea;\n$color-purple-700: #7c3aed;\n$color-purple-800: #6b21a8;\n$color-purple-900: #581c87;\n\n// Indigo Colors\n$color-indigo-50: #eef2ff;\n$color-indigo-100: #e0e7ff;\n$color-indigo-200: #c7d2fe;\n$color-indigo-300: #a5b4fc;\n$color-indigo-400: #818cf8;\n$color-indigo-500: #6366f1;\n$color-indigo-600: #4f46e5;\n$color-indigo-700: #4338ca;\n$color-indigo-800: #3730a3;\n$color-indigo-900: #312e81;\n\n// yellow Colors\n$color-yellow-50: #fefce8;\n$color-yellow-100: #fef9c3;\n$color-yellow-200: #fef08a;\n$color-yellow-300: #fde047;\n$color-yellow-400: #facc15;\n$color-yellow-500: #eab308;\n$color-yellow-600: #ca8a04;\n$color-yellow-700: #a16207;\n$color-yellow-800: #854d0e;\n$color-yellow-900: #713f12;\n\n// Orange Colors\n$color-orange-50: #fff7ed;\n$color-orange-100: #ffedd5;\n$color-orange-200: #fed7aa; \n$color-orange-300: #fdba74;\n$color-orange-400: #fb923c;\n$color-orange-500: #f97316;\n$color-orange-600: #ea580c;\n$color-orange-700: #c2410c;\n$color-orange-800: #9a3412;\n$color-orange-900: #7c2d12;\n\n// pink Colors\n$color-pink-50: #fdf2f8;\n$color-pink-100: #fce7f3;\n$color-pink-200: #fbcfe8;\n$color-pink-300: #f9a8d4;\n$color-pink-400: #f472b6;\n$color-pink-500: #ec4899;\n$color-pink-600: #db2777;\n$color-pink-700: #be185d;\n$color-pink-800: #9d174d;\n$color-pink-900: #831843;\n","@import './breakpoints';\n\n// ====================================\n// 📱 Media Query Mixins\n// ====================================\n@mixin respond-sm {\n  @media (max-width: $breakpoint-sm) {\n    @content;\n  }\n}\n\n@mixin respond-md {\n  @media (max-width: $breakpoint-md) {\n    @content;\n  }\n}\n\n@mixin respond-lg {\n  @media (max-width: $breakpoint-lg) {\n    @content;\n  }\n}\n\n@mixin respond-xlg {\n  @media (max-width: $breakpoint-xlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxlg {\n  @media (max-width: $breakpoint-xxlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxxlg {\n  @media (max-width: $breakpoint-xxxlg) {\n    @content;\n  }\n}\n\n@mixin respond-max {\n  @media (max-width: $breakpoint-max) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
